import { action } from "@ember/object"
import Component from "@glimmer/component"
import { tracked } from "@glimmer/tracking"
import ObjectId from "@shared/util/object-id-gen"
import styles from "./date-selector.module.css"

interface Args {
  setNewDate: Function
  firstDayOfSchoolYear: string
  lastDayOfSchoolYear: string
  dateString: string
}

export default class DateSelectorComponent extends Component<Args> {
  readonly styles = styles

  @tracked dateMenuIsOpen = false
  @tracked dateCenter = null

  elementId = "date-selector-" + ObjectId.create()

  // get myElementId() {
  //   return "date-selector-" + ObjectId.create()
  // }

  // If we want to force the user to select days within the calendar
  // firstDate: Ember.computed('rotationCalendar.attributes.semesters.@each.startDate', function(){
  //   return _.min(_.map(get(this, 'rotationCalendar.attributes.semesters'), "startDate"))
  // }),
  //
  // lastDate: Ember.computed('rotationCalendar.attributes.semesters.@each.startDate', function(){
  //   return _.min(_.map(get(this, 'rotationCalendar.attributes.semesters'), "endDate"))
  // }),

  @action
  setDate({ date }) {
    this.args.setNewDate(dateFns.format(date, "YYYY-MM-DD"))
    this.dateMenuIsOpen = false
  }
  @action
  setDateCenter({ date }) {
    this.dateCenter = dateFns.format(date, "YYYY-MM-DD")
  }

  @action
  setDateToToday() {
    this.args.setNewDate(dateFns.format(new Date(), "YYYY-MM-DD"))
    this.dateMenuIsOpen = false
  }

  @action
  setDateToFirstDay() {
    this.args.setNewDate(this.args.firstDayOfSchoolYear)
    this.dateMenuIsOpen = false
  }

  @action
  setDateToLastDay() {
    this.args.setNewDate(this.args.lastDayOfSchoolYear)
    this.dateMenuIsOpen = false
  }

  @action closeMenu() {
    this.dateMenuIsOpen = false
  }
}
